import { scroller } from 'react-scroll'

export const COLLAPSE_TYPES = {
  DETAILS: 'Details',
  FOR_SALE: 'For Sale',
  FOR_RENT: 'For Rent',
  VALUES_AND_TRENDS: 'Values & Trends',
  AMENITIES: 'Amenities',
  FLOOR_PLAN: 'Floor Plan',
  PRICE_TREND: 'Historical Average Price Per Square Foot',
  PRICE_TREND_MOBILE: 'Historical Avg. ppsf',
  PRICE_COMPARISON: 'Comparable Buildings',
  SALE_RENT_PRICE: 'Sale and Rent Prices',
  PRICE_HISTORY: 'Price History',
  MAINT_FEE_TREND: 'Historical Maintenance Fees',
  NEARBY_LISTINGS: 'Nearby Listings',
  SIMILAR_LISTINGS: 'Similar Listings',
  DEMOGRAPHICS: 'Demographics',
  NEARBY_SCHOOLS: 'Nearby Schools',
  PRICING: 'Pricing',
  FLOORPLAN: 'Floorplan',
}

export const scrollOffset = -84

export const scrollToCollapsible = ({ section, offset, containerId, ...options }) => {
  scroller.scrollTo(section, {
    // often does not move to right position
    // Offset doesn't work if duration is not set - even 0
    duration: 0, // DO NOT REMOVE THIS
    // smooth: true,
    // delay: 100,
    offset: offset || scrollOffset,
    ...options,
    ...(containerId && { containerId }),
  })
}

export const FLOATING_PANEL_LINKS = {
  OVERVIEW_AND_PRICE_HISTORY: 'OverviewAndPriceHistory',
  KEY_FACTS_AND_LISTING_DETAILS: 'KeyFactsAndListingDetails',
  ESTIMATE: 'Estimate',
  COMPARABLE_SALES: 'comparableSales',
  DEMOGRAPHICS: 'Demographics',
  AMENITIES: 'Amenities',
  SIMILAR_LISTINGS: 'SimilarListings',
  VALUES_AND_TRENDS: 'ValuesTrends',
  NEARBY_LISTINGS: 'NearbyListings',
  PROJECT_INFO: 'ProjectInfo',
  PRECON_LISTINGS: 'PreconListings',
  NEARBY_SCHOOLS: 'NearbySchools',
  PRICING: 'Pricing',
  FLOORPLAN: 'Floorplan',
  CALCULATOR: 'Calculator',
}
